import { Directive, HostBinding, NgModule } from '@angular/core';

@Directive({
  selector: '[systemCheckbox]',
})
export class CheckboxDirective {
  @HostBinding('class') className =
    'text-system-600 border border-gray-300 rounded focus:ring-system-500 dark:focus:ring-system-600 dark:ring-offset-gray-800 focus:ring-3 dark:bg-gray-700 dark:border-gray-600';
  constructor() {}
}

@NgModule({
  declarations: [CheckboxDirective],
  exports: [CheckboxDirective],
})
export class SystemCheckboxModule {}
